<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="buy-point">
      <Title jpn="Buy points" />
      <!-- <div class="carrer_memo">
        If you would like to pay with "carrier billing, Merpay, LINEPay, PayPay", you can also purchase at <a href="https://www.iranoan.com/blank-3/Point-for-Get24" target="_blank">minny online store!</a><br>
        If you would like your points to be reflected immediately, please select payment by credit card. Other payment methods may take longer.</div> -->
      <div class="point_course_area">
        <div class="rate">*FX rate : as of {{rateDate}}</div>
        <GrayBack
          class="gray_area"
          v-for="(pointPriceItem) in pointPriceList" :key="pointPriceItem.id"
        >
          <PointCourse
            class="point-course"
            :point="pointPriceItem.point"
            :price="pointPriceItem.price"
            :doller="pointPriceItem.doller"
            :memo="pointPriceItem.memo"
            @handleBuyBtnClick="buyPoint(pointPriceItem.id)"
          />
        </GrayBack>
      </div>
      <div class="notation-area">
        <ShadowButton
          class="shadow-button"
          :text="t('特定商取引法に基づく表記')"
          @handleShadowBtnClick="goToSpecificCommerce"
        />
        <ShadowButton
          class="shadow-button"
          :text="t('資金決済法に基づく表記')"
          @handleShadowBtnClick="goToFundSettlement"
        />
        <ShadowButton
          class="shadow-button"
          :text="t('ポイント利用規約')"
          @handleShadowBtnClick="goToPointTermsOfService"
        />
      </div>
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import ShadowButton from '@/components/molecules/ShadowButton.vue';
import PointCourse from '@/components/organisms/PointCourse.vue';
import Title from '@/components/molecules/Title.vue';
import GrayBack from '@/components/molecules/GrayBack.vue';
import t from '@/plugins/i18n';

export default {
  name: 'BuyPoint',
  mixins: [t],

  components: {
    BaseTemplate,
    ShadowButton,
    PointCourse,
    Title,
    GrayBack,
  },

  data: () => ({
    rateDate: '',
  }),

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
      pointPriceList: 'pointPrice/pointPriceList',
    }),
  },

  watch: {
    pointPriceList(newVal) {
      if (newVal) {
        let baseDate = new Date('2000-01-01 00:00:00');
        for (let i = 0; i < newVal.length; i += 1) {
          const date = new Date(newVal[i].modified);
          if (baseDate < date) {
            baseDate = date;
          }
        }
        this.rateDate = `${baseDate.getMonth() + 1}/${baseDate.getDate()}/${baseDate.getFullYear()}`;
      }
    },
  },

  created() {
    const pageNumber = 1;
    this.$store.dispatch('pointPrice/setPointPriceList', { pageNumber });
  },

  methods: {
    buyPoint(pointPriceId) {
      const query = {
        pointPriceId,
      };
      this.$router.push({ path: '/confirm-buy-point', query });
    },
    goToSpecificCommerce() {
      this.$router.push('/specific-commerce');
    },
    goToFundSettlement() {
      this.$router.push('/fund-settlement');
    },
    goToPointTermsOfService() {
      this.$router.push('/point-terms-of-service');
    },
    goToBuyPointHistory() {
      this.$router.push('/buy-point-history');
    },
  },
};
</script>

<style lang="scss" scoped>
.carrer_memo {
  margin-top: 10px;
  color: $white;
  font-size: 80%;
  a {
    color: $white!important;
  }
}
.buy-point{
  width: 100%;
  max-width: 750px;
  min-height: 100%;
  padding: 30px 10px 33px 10px;
  margin: 0 auto;
  .point_course_area {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    .gray_area {
      width: 100%;
      margin: 5px 0;
      padding: 0;
    }
    .point-course{
      width: 100%;
      height: auto;
    }
    .rate {
      text-align: right;
      color: $white;
    }
  }
  .notation-area {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin-top: 50px;
    text-align: center;
    .shadow-button {
      width: 255px;
      height: 40px;
      color: $white;
    }
  }
}
@media screen and  (max-width: $tabletWidth) {
  .leaf_area {
    flex-direction: column;
  }
  .buy-point {
    .notation-area {
      margin-top: 20px;
      flex-direction: row;
      white-space: nowrap;
    }
  }
  .shadow-button {
    font-size: 10px;
  }
}
</style>
